<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
		
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

                        <el-form-item :label="$t('accountApplyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountApplyList.statusStr.0')" :value="0"></el-option>
								<el-option :label="$t('accountApplyList.statusStr.1')" :value="1"></el-option>
								<el-option :label="$t('accountApplyList.statusStr.2')" :value="2"></el-option>
								<el-option :label="$t('accountApplyList.statusStr.3')" :value="3"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('accountApplyList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
                <el-table-column align="center" prop="id" width="50" label="ID">
				</el-table-column>
				<el-table-column align="center" prop="apply_title" :label="$t('accountApplyList.apply_title')">
                    <template slot-scope="scope">
									<div v-if="scope.row.apply_title.length > 10">
										{{ scope.row.apply_title.substring(0, 10) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.apply_title)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										<div v-if="scope.row.apply_title.length > 0">{{ scope.row.apply_title }}</div>
										<div v-else> -- </div>
									</div>
								</template>
				</el-table-column>
                <el-table-column align="center" prop="status" width="100" :label="$t('accountApplyList.status')">
                    <template slot-scope="scope">
						<span v-if="scope.row.status == 0">{{$t('accountApplyList.statusStr.0') }}</span>
						<span v-if="scope.row.status == 1" class="text-success">{{$t('accountApplyList.statusStr.1') }}</span>
						<span v-if="scope.row.status == 2" class="text-danger">{{$t('accountApplyList.statusStr.2') }}</span>
						<span v-if="scope.row.status == 3" class="text_chengse">{{$t('accountApplyList.statusStr.3') }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="remark" :label="$t('accountApplyList.remark')">
                    <template slot-scope="scope">
									<div v-if="scope.row.remark.length > 10">
										{{ scope.row.remark.substring(0, 10) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.remark)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										<div v-if="scope.row.remark.length > 0">{{ scope.row.remark }}</div>
										<div v-else> -- </div>
									</div>
								</template>
				</el-table-column>
				<el-table-column align="center" prop="create_time" width="190" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center"  width="100" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" :disabled="scope.row.status !== 0" plain type="primary" v-auth="'editAdmin'" @click="cancelModel(scope)">{{$t('layout.cancel')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

        

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountApplyList.edit') : $t('accountApplyList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('accountApplyList.accountType')" >
					<el-input  clearable disabled size="small" style="width: 85%;" :value="$t('accountApplyList.accountTypeStrTx')"></el-input>
				</el-form-item>

                <el-form-item :label="$t('accountApplyList.content')" prop="apply_title">
					<el-input v-model="form.apply_title" clearable size="small" :placeholder="$t('accountApplyList.content')"  style="width: 85%;"></el-input>
				</el-form-item>
            
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('accountApplyList.msgTitle')">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				cloud_id:3,
				dialogTitleVisible: false,
				fullTitle: '',

                payInfoModel: false,

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
                    status:-1,
					time:[],
				},
				auth_val: 'AccountApply',

                prop: 'id',
                sort: 'descending',

                type: 1,

				preUrl: "user/accountApplyList", //列表
				addUrl: "user/addAccountApply", //添加/修改

				pay_info: [],

				tableData: [],
				form: {
                    
				},
				rules: {
					
				},
				Apply_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			
		},
		methods: {
            hidePayModel() {
            	// 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						parent: '',
					}
				this.editIndex = -1
                this.createModel = false
                this.payInfoModel = false
				this.getList()
            },
		    
            // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
            cancelModel(res){
				 // 添加确认对话框
				 this.$confirm(
					this.$t('message.cancelConfirm'), // 确认提示内容
					this.$t('message.confirmTitle'),  // 对话框标题
					{
						confirmButtonText: this.$t('system.confirm'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}
				).then(() => {
					// 用户确认后执行原逻辑
					this.layout.loading = true;
					this.axios.post('/admin/user/editStatusAccountApply', {
						id: res.row.id,
					}, {
						token: true
					}).then(res => {
						let all = res.data
						if (all.code == 1) {
							this.$message({
								message: all.msg,
								type: 'success'
							}); // 控制是否顯示成功提示
						}
						this.layout.loading = false;
						this.loading = false;
						this.getList()
					}).catch(err => {
						this.layout.loading = false;
						this.userInfoModel = false;
					})
				}).catch(() => {
					// 用户取消时可选操作
					this.$message({
						type: 'info',
						message: this.$t('message.cancelOperate')
					});
				});
            },
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.form.type = this.type
						this.addOrEdit(this.form)
					}
				})
			},
			hide(){
                // 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						parent: '',
					}
					this.editIndex = -1
                    this.createModel = false
            },
            copyAddress() {
                // 实现复制地址逻辑
                navigator.clipboard.writeText(this.pay_info.trc)
            },
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						name_lang: '',
						parent: '',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						name_lang: e.row.name_lang,
						parent:  e.row.parent,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					status:-1,
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>
<style lang="scss"> /* 使用 SCSS/SASS 预处理器 */
    .recharge-form {
  .el-form-item__label {
    font-weight: bold;
  }

  .address-input {
    .el-input__inner {
      font-family: monospace; /* 更适合地址显示 */
    }
  }

  .qrcode-container {
    text-align: center;
    margin: 0 auto;
    
    .qrcode-image {
      width: 200px;
      height: 200px;
      border: 1px solid #eee;
      padding: 10px;
      border-radius: 4px;
      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
      }
    }

    .qrcode-placeholder {
      width: 200px;
      height: 200px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      margin: 0 auto;
    }

    .qrcode-tip {
      color: #666;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>

